import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import StarRateIcon from '@mui/icons-material/StarRate';
import Reasons from "./Reasons";
import BetOption from "./BetOption";
import PropReason from "./PropReason";

const PickPropCard = ({ sportcode, teamid, projected_wins }) => {

    const [selectedBook, setSelectedBook] = useState('Consensus')
    const [vsTeamId, setVsTeamId] = useState(0)

    const [propData, setPropData] = useState({});

    const [loading, setLoading] = useState(true);
    const [propLoading, setIsPropLoading] = useState(false)

    const [position, setPosition] = useState('');
    const [showReason, setShowReason] = useState(false);
    const [propReasons, setPropReasons] = useState(null);
    const [propReasonParam, setpropReasonParam] = useState({
        teamid: 0,
        playerid: 0,
        sdplayerid: 0
    });

    const books = ["BetMGM", "Caesars", "Consensus", "DraftKings", "Fanduel", "PointsBet"]


    const getStarClassName = function (prop, index) {

        let clname = 'star_rate material-icons fs-3 ';

        if (prop.OverUnder == 'Over') {

            if (prop.Stars >= index) {

                clname += 'text-danger';
            }
            else {

                clname += 'star-light-red';
            }
        }
        else {

            if (prop.Stars >= index) {

                clname += 'text-primary';
            }
            else {

                clname += 'star-light-blue';
            }
        }

        return clname;

    };
    const handlePosClickXX = function (e, pos) {
        e.preventDefault();
        let anchors = e.target.parentNode.getElementsByTagName('a');
        for (var i = 0; i < anchors.length; i++) {
            anchors[i].classList.add('text-decoration-none');
        }
        e.target.classList.remove('text-decoration-none');
        setPosition(pos);
    };

    const handlePosClick = function (pos) {
        
        setPosition(pos);
    };
    
    const handleBetNow = function () {
        /*   window.open('https://join.pointsbet.com/1x5002nd/?token=Qzw31Tx2ebu3hAg8rbi-cGNd7ZgqdRLk&promo=INSIDEEDGE', '_blank');*/
        window.open('https://promo.nj.betmgm.com/en/promo/geolocator?orh=casino.betmgm.com', '_blank');
    }

    const toggleShowReason = (playerId, sdplayerid, playerName, teamId, vsTeam, pUnit, propsUnit) => {

        if (showReason == false) {
            let param = {
                playerId: playerId,
                sdplayerid: sdplayerid,
                playerName: playerName,
                teamId: teamId,
                vsTeam: vsTeam,
                pUnit: pUnit,
                propsUnit: propsUnit,
                sbook: selectedBook
            };
            setpropReasonParam(param);
        }
        setShowReason(p => !p);
    }

    const initPropReasons = (props) => {
        
        /*console.log("initPropReasons", props)*/
        let pReasons = null;

        //props = props.filter(p => p.TeamId === teamid);
        
        //if (sportcode?.toLowerCase() === "mlb") {
        //    console.log("MLB", props)
        //}
        //else {
        //    if (props && props.length > 0) {

        //        pReasons = {};
        //        for (var i = 0; i < props.length; i++) {

        //            let prop = props[i];

        //            if (!(prop.Position in pReasons)) {

        //                pReasons[prop.Position] = {}
        //            }

        //            let propPositions = pReasons[prop.Position];

        //            if (!(prop.PlayerID in propPositions)) {

        //                propPositions[prop.PlayerID] = {
        //                    PlayerName: prop.PlayerName,
        //                    SDPlayerId: prop.SDPlayerId
        //                };
        //            }

        //            let propPlayers = propPositions[prop.PlayerID];

        //            if (!(prop.ProjectionUnit in propPlayers)) {

        //                propPlayers[prop.ProjectionUnit] = {
        //                    ReasonATotal: 0,
        //                    ReasonsA: [],
        //                    ReasonAStars: 0,
        //                    ReasonBTotal: 0,
        //                    ReasonBStars: 0,
        //                    ReasonsB: [],
        //                    OverUnder: '',
        //                    Stars: 0,
        //                    PropVal: prop.PropVal
        //                };
        //            }

        //            let propPunits = propPlayers[prop.ProjectionUnit];
        //            propPunits.ReasonATotal += prop.ReasonA ?? 0;
        //            propPunits.ReasonBTotal += prop.ReasonB ?? 0;

        //            if (prop.ReasonA > 0) {
        //                propPunits.ReasonsA.push(prop.FullNote);
        //                propPunits.ReasonAStars = Math.round((propPunits.ReasonATotal / 2.0) + 0.5)
        //            }
        //            else if (prop.ReasonB > 0) {
        //                propPunits.ReasonsB.push(prop.FullNote);
        //                propPunits.ReasonBStars = Math.round((propPunits.ReasonBTotal / 2.0) + 0.5);
        //            }

        //            if (propPunits.ReasonATotal > propPunits.ReasonBTotal) {
        //                propPunits.OverUnder = 'Over';
        //            }
        //            else if (propPunits.ReasonATotal < propPunits.ReasonBTotal) {
        //                propPunits.OverUnder = 'Under'
        //            }
        //            else if (propPunits.ReasonATotal == propPunits.ReasonBTotal) {
        //                propPunits.OverUnder = 'Neutral'
        //            }
        //            else {
        //                propPunits.OverUnder = '';
        //            }

        //            if (propPunits.ReasonATotal > propPunits.ReasonBTotal) {
        //                propPunits.Stars = Math.round((propPunits.ReasonATotal / 2.0) + 0.5);
        //            }
        //            else if (propPunits.ReasonATotal < propPunits.ReasonBTotal) {
        //                propPunits.Stars = Math.round((propPunits.ReasonBTotal / 2.0) + 0.5);
        //            }
        //            else if (propPunits.ReasonATotal == propPunits.ReasonBTotal) {
        //                propPunits.Stars = Math.round((propPunits.ReasonATotal / 2.0) + 0.5);
        //            }
        //            else {
        //                propPunits.Stars = 0;
        //            }

        //        }

        //    }
        //}

        if (props && props.length > 0) {

            pReasons = {};
            for (var i = 0; i < props.length; i++) {

                let prop = props[i];

                if (!(prop.Position in pReasons)) {

                    pReasons[prop.Position] = {}
                }

                let propPositions = pReasons[prop.Position];

                if (!(prop.PlayerID in propPositions)) {

                    propPositions[prop.PlayerID] = {
                        PlayerName: prop.PlayerName,
                        SDPlayerId: prop.SDPlayerId
                    };
                }

                let propPlayers = propPositions[prop.PlayerID];

                if (!(prop.ProjectionUnit in propPlayers)) {

                    propPlayers[prop.ProjectionUnit] = {
                        ReasonATotal: 0,
                        ReasonsA: [],
                        ReasonAStars: 0,
                        ReasonBTotal: 0,
                        ReasonBStars: 0,
                        ReasonsB: [],
                        OverUnder: '',
                        Stars: 0,
                        PropVal: prop.PropVal
                    };
                }

                let propPunits = propPlayers[prop.ProjectionUnit];
                propPunits.ReasonATotal += prop.ReasonA ?? 0;
                propPunits.ReasonBTotal += prop.ReasonB ?? 0;

                if (prop.ReasonA > 0) {
                    propPunits.ReasonsA.push(prop.FullNote);
                    propPunits.ReasonAStars = Math.round((propPunits.ReasonATotal / 2.0) + 0.5)
                }
                else if (prop.ReasonB > 0) {
                    propPunits.ReasonsB.push(prop.FullNote);
                    propPunits.ReasonBStars = Math.round((propPunits.ReasonBTotal / 2.0) + 0.5);
                }

                if (propPunits.ReasonATotal > propPunits.ReasonBTotal) {
                    propPunits.OverUnder = 'Over';
                }
                else if (propPunits.ReasonATotal < propPunits.ReasonBTotal) {
                    propPunits.OverUnder = 'Under'
                }
                else if (propPunits.ReasonATotal == propPunits.ReasonBTotal) {
                    propPunits.OverUnder = 'Neutral'
                }
                else {
                    propPunits.OverUnder = '';
                }

                if (propPunits.ReasonATotal > propPunits.ReasonBTotal) {
                    propPunits.Stars = Math.round((propPunits.ReasonATotal / 2.0) + 0.5);
                }
                else if (propPunits.ReasonATotal < propPunits.ReasonBTotal) {
                    propPunits.Stars = Math.round((propPunits.ReasonBTotal / 2.0) + 0.5);
                }
                else if (propPunits.ReasonATotal == propPunits.ReasonBTotal) {
                    propPunits.Stars = Math.round((propPunits.ReasonATotal / 2.0) + 0.5);
                }
                else {
                    propPunits.Stars = 0;
                }

            }

        }

        setPropReasons(pReasons);
    }

    const handleSportsBookClick = (e, book) => {
        e.preventDefault()
        setPropData([])
        setSelectedBook(book)

    }

    useEffect(() => {
        
        async function fetchData() {
            const resp = await fetch(`/${sportcode}/PickPropCard?teamid=${teamid}&sportsbook=${selectedBook}`);
            const result = await resp.json();
            
            setPropData(result);
            console.log("setPropData", result)
            if (result) {
                setVsTeamId(result.VsTeamId)
                if (result.Props && result.Props.length > 0) {
                    setPosition(result.Props[0].Position);
                }
                initPropReasons(result.Props);
            }
            setLoading(false);
        }

        fetchData();
    }, [sportcode, teamid, selectedBook]);

    const propCardStyles = {
        maxHeight: "1200px",
        height: "100%",
        overflowY: "auto"

    }

    return (

        <div className="card" style={propCardStyles}>

            <div className="card-header">
                <h3 className="text-center">Picks and Props</h3>
            </div>

            <div className="card-body text-center">

                {
                    loading ? (
                        <Spinner className="mx-auto d-block">
                            <span className="visually-hidden">Loading...</span>
                        </Spinner>
                    ) : (

                        propData ? (

                            <>
                                {
                                    sportcode.toLowerCase() === 'nfl'
                                        ? <h4 className="text-center fs-3">{propData.Week ? `WEEK ${propData.Week} Vs ${propData.VsTeamName}` : ''}</h4>
                                        : <h4 className="text-center fs-3">{propData.VsTeamName ? ` Vs ${propData.VsTeamName}` : ''}</h4>
                                }


                                <div className="d-flex justify-content-center">
                                    <span className="my-auto fs-4 fw-bold me-2">STAR RATING: </span>
                                    <StarRateIcon className="align-middle display-6" fontSize="large" style={{ fill: propData.Stars >= 1 ? '#ffa730' : '#DFDFDF' }}></StarRateIcon>
                                    <StarRateIcon className="align-middle display-6" fontSize="large" style={{ fill: propData.Stars >= 2 ? '#ffa730' : '#DFDFDF' }}></StarRateIcon>
                                    <StarRateIcon className="align-middle display-6" fontSize="large" style={{ fill: propData.Stars >= 3 ? '#ffa730' : '#DFDFDF' }}></StarRateIcon>
                                    <StarRateIcon className="align-middle display-6" fontSize="large" style={{ fill: propData.Stars >= 4 ? '#ffa730' : '#DFDFDF' }}></StarRateIcon>
                                    <StarRateIcon className="align-middle display-6" fontSize="large" style={{ fill: propData.Stars >= 5 ? '#ffa730' : '#DFDFDF' }}></StarRateIcon>
                                </div>


                                {propData.Stars >= 4 && !propData.StarsFav ? (

                                    <>

                                        <BetOption
                                            sportcode={sportcode}
                                            gameid={propData.GameId}
                                        ></BetOption>

                                    </>

                                ) : (

                                    <>

                                        <p>{propData.PickNote ?? ''}</p>

                                        <div>

                                            {
                                                propData.StarsFavId ? (

                                                    <div className="d-flex justify-content-center">

                                                        <picture>
                                                            <source srcSet={`/_ie/_${sportcode}_teams_sm/${propData.StarsFavId}.webp`} type="image/webp" />
                                                            <img src={`/_ie/_${sportcode}_teams_sm/${propData.StarsFavId}.png`} className="tlogo" alt={propData.StarsFav ? `${propData.StarsFav} logo` : ''} />
                                                        </picture>


                                                        <label className="d-block fs-3 fw-bold my-auto m-2">{propData.MoneyLine > 0 ? `+${propData.MoneyLine}` : propData.MoneyLine}</label>

                                                    </div>

                                                ) : ('')

                                            }


                                        </div>

                                        <div>
                                            <Reasons
                                                sportcode={sportcode}
                                                proj_id={propData.Proj_Id}
                                                gameid={propData.GameId}
                                                label={"Reasons"}
                                                teamid={teamid}
                                                homeid={propData.HomeId}
                                                homename={propData.HomeName}
                                                awayid={propData.AwayId}
                                                awayname={propData.AwayName}
                                            ></Reasons>

                                            <button type="button"
                                                onClick={handleBetNow}
                                                className="btn btn-primary">Bet Now</button>
                                        </div>

                                    </>
                                )}

                                <div>

                                    {propReasons ? (

                                        <>
                                            <div className="container-fluid border py-2">
                                                <div className="row justify-content-center">
                                                    <div className="col d-flex align-items-center p-0 mx-auto justify-content-center">
                                                        <div className="position">
                                                            <Positions
                                                                sportCode={sportcode}
                                                                props={propReasons}
                                                                onSelect={handlePosClick}
                                                            />
                                                        </div>
                                                        <div className="dropdown ms-2">
                                                            <button
                                                                className="btn btn-outline-dark btn-sm dropdown-toggle"
                                                                type="button"
                                                                id="dropdownMenuButton"
                                                                data-bs-toggle="dropdown" // Bootstrap's dropdown toggle
                                                                aria-expanded="false"
                                                            >
                                                                {selectedBook}
                                                            </button>
                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                                                {books.map((b, index) => (
                                                                    <li key={b + index}>
                                                                        <a className="dropdown-item" href="#" onClick={(event) => handleSportsBookClick(event, b)}>
                                                                            {b}
                                                                        </a>
                                                                    </li>
                                                                ))}
                                                            </ul>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="mx-2 px-2">
                                                {
                                                    propData?.length <= 0 ? (
                                                        <Spinner className="mx-auto d-block">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </Spinner>
                                                        ) :
                                                            Object.keys(propReasons[position]).map(playerid => (
                                                                <PropTable
                                                                    key={playerid}
                                                                    player={playerid}
                                                                    position={position}
                                                                    propReasons={propReasons}
                                                                    toggleShowReason={toggleShowReason}
                                                                    propData={propData}
                                                                />
                                                            ))

                                                        //Object.keys(propReasons[position]).map(playerid => (
                                                        //    <table key={playerid} className="table table-striped text-center caption-top">
                                                        //        <caption className="text-center">
                                                        //            <h4>{`${propReasons[position][playerid].PlayerName} ${position}`}
                                                        //            </h4>
                                                        //        </caption>
                                                        //        <thead>
                                                        //            <tr className="text-uppercase">
                                                        //                <th scope="col">Prop</th>
                                                        //                <th scope="col">Pick</th>
                                                        //                <th scope="col">Rating</th>
                                                        //            </tr>
                                                        //        </thead>
                                                        //        <tbody>
                                                        //            {
                                                        //                Object.keys(propReasons[position][playerid])
                                                        //                    .filter(punit => punit != 'PlayerName' && punit != 'SDPlayerId')
                                                        //                    .map(function (punit) {

                                                        //                        let pr = propReasons[position][playerid][punit];

                                                        //                        return (
                                                        //                            <tr key={punit} className="text-center"
                                                        //                                style={{ cursor: "pointer" }}
                                                        //                                onClick={() => toggleShowReason(
                                                        //                                    playerid,
                                                        //                                    propReasons[position][playerid].SDPlayerId,
                                                        //                                    propReasons[position][playerid].PlayerName,
                                                        //                                    propData.StarsFavId,
                                                        //                                    propData.StarsFavId == propData.HomeId ? propData.AwayName : propData.HomeName,
                                                        //                                    punit,
                                                        //                                    pr)}>
                                                        //                                <td className="text-start" scope="row">{punit}</td>
                                                        //                                <td>{`${pr.OverUnder} ${pr.PropVal}`}</td>
                                                        //                                <td><span className={getStarClassName(pr, 1)}>star_rate</span>
                                                        //                                    <span className={getStarClassName(pr, 2)}>star_rate</span>
                                                        //                                    <span className={getStarClassName(pr, 3)}>star_rate</span>
                                                        //                                    <span className={getStarClassName(pr, 4)}>star_rate</span>
                                                        //                                    <span className={getStarClassName(pr, 5)}>star_rate</span>
                                                        //                                </td>
                                                        //                            </tr>
                                                        //                        )
                                                        //                    })

                                                        //            }
                                                        //        </tbody>
                                                        //    </table>
                                                        //))
                                                }
                                            </div>
                                        </>
                                    ) : ''}



                                </div>

                                <PropReason
                                    sportcode={sportcode}
                                    showReason={showReason}
                                    toggleShowReason={toggleShowReason}
                                    param={propReasonParam}

                                >

                                </PropReason>

                            </>

                        ) : (

                            <div>
                                <p>Picks and Props are typically available 2-3 days before the next game.</p>
                                {
                                    sportcode === "MLB" &&
                                    (<p className="fs-5">2023 Projected Total: {projected_wins} wins</p>)

                                }

                            </div>

                        )
                    )}

            </div>
        </div>

    );
};
export default PickPropCard

export const Positions = ({ sportCode, props, onSelect }) => {
    const [selectedPosition, setSelectedPosition] = useState(null);

    const positions = sportCode?.toLowerCase() === "mlb" ? ['H', 'P'] : [...Object.keys(props)];
    
    const handleClick = (position) => {
        setSelectedPosition(position);
        onSelect(position);
    };

    return (
        <>
            {positions.map((position, idx) => (
                <a
                    href="#"
                    className={selectedPosition === position ? "m-2 fw-bolder text-dark" : "m-2 text-secondary"}
                    key={position}
                    onClick={() => handleClick(position)}
                >
                    {position}
                </a>
            ))}
        </>
    );
};

export const PropTableX = ({ player, position, propReasons, toggleShowReason, propData }) => {
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const shouldShowMobileView = windowWidth < 562 || (windowWidth > 1199 && windowWidth < 1512);

    const getStarClassName = function (prop, index) {
        let clname = 'star_rate material-icons fs-5 ';
        if (prop.OverUnder == 'Over') {
            if (prop.Stars >= index) {
                clname += 'text-danger';
            }
            else {
                clname += 'star-light-red';
            }
        }
        else {
            if (prop.Stars >= index) {
                clname += 'text-primary';
            }
            else {
                clname += 'star-light-blue';
            }
        }
        return clname;
    };

    const togglePanel = (punit) => {
        setExpandedRows(prev => {
            const newSet = new Set(prev);
            if (newSet.has(punit)) {
                newSet.delete(punit);
            } else {
                newSet.add(punit);
            }
            return newSet;
        });
    };

    return (
        <div className="table-responsive">
            <table className="table table-striped text-center caption-top">
                <caption className="text-center">
                    <h4>{`${propReasons[position][player].PlayerName} ${position}`}</h4>
                </caption>
                <thead>
                    <tr>
                        <th scope="col">{shouldShowMobileView ? 'Prop' : 'Prop'}</th>
                        {!shouldShowMobileView && (
                            <>
                                <th scope="col">Pick</th>
                                <th scope="col">Rating</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(propReasons[position][player])
                        .filter(punit => punit != 'PlayerName' && punit != 'SDPlayerId')
                        .map(punit => {
                            let pr = propReasons[position][player][punit];
                            const isExpanded = expandedRows.has(punit);

                            if (shouldShowMobileView) {
                                return (
                                    <React.Fragment key={punit}>
                                        <tr>
                                            <td className="p-0">
                                                <div
                                                    className="d-flex justify-content-between align-items-center p-3"
                                                    onClick={() => togglePanel(punit)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span>{punit}</span>
                                                    <span className={`text-primary transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}>
                                                        {isExpanded ? '−' : '+'}
                                                    </span>
                                                </div>

                                                <div
                                                    className={`
                                                        overflow-hidden transition-all duration-300 ease-in-out
                                                        ${isExpanded ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}
                                                    `}
                                                >
                                                    <div
                                                        className="border-t p-3"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleShowReason(
                                                                player,
                                                                propReasons[position][player].SDPlayerId,
                                                                propReasons[position][player].PlayerName,
                                                                propData.StarsFavId,
                                                                propData.StarsFavId == propData.HomeId ? propData.AwayName : propData.HomeName,
                                                                punit,
                                                                pr
                                                            );
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <div className="mb-3 flex flex-row gap-x-2 justify-start items-center">
                                                            <strong>Pick: </strong>
                                                            <span>{`${pr.OverUnder} ${pr.PropVal}`}</span>
                                                        </div>
                                                        <div className="flex flex-row gap-x-2 justify-start items-center">
                                                            <strong>Rating: </strong>
                                                            <div className="d-flex justify-content-center gap-1">
                                                                {[1, 2, 3, 4, 5].map(star => (
                                                                    <span key={star} className={getStarClassName(pr, star)}>
                                                                        star_rate
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                );
                            }

                            return (
                                <tr key={punit}>
                                    <td className="text-start">{punit}</td>
                                    <td>{`${pr.OverUnder} ${pr.PropVal}`}</td>
                                    <td>
                                        <div className="d-flex justify-content-center gap-1">
                                            {[1, 2, 3, 4, 5].map(star => (
                                                <span key={star} className={getStarClassName(pr, star)}>
                                                    star_rate
                                                </span>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
};

export const PropTable = ({ player, position, propReasons, toggleShowReason, propData }) => {
    const [expandedRows, setExpandedRows] = useState(new Set());
    const [windowWidth, setWindowWidth] = useState(window.innerWidth);

    useEffect(() => {
        const handleResize = () => setWindowWidth(window.innerWidth);
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const shouldShowMobileView = windowWidth < 562 || (windowWidth > 1199 && windowWidth < 1512);

    const getStarClassName = function (prop, index) {
        let clname = 'star_rate material-icons fs-5 ';
        if (prop.OverUnder == 'Over') {
            if (prop.Stars >= index) {
                clname += 'text-danger';
            }
            else {
                clname += 'star-light-red';
            }
        }
        else {
            if (prop.Stars >= index) {
                clname += 'text-primary';
            }
            else {
                clname += 'star-light-blue';
            }
        }
        return clname;
    };

    const togglePanel = (punit) => {
        setExpandedRows(prev => {
            const newSet = new Set(prev);
            if (newSet.has(punit)) {
                newSet.delete(punit);
            } else {
                newSet.add(punit);
            }
            return newSet;
        });
    };

    return (
        <div className="table-responsive">
            <table className="table table-striped text-center caption-top">
                <caption className="text-center">
                    <h4>{`${propReasons[position][player].PlayerName} ${position}`}</h4>
                </caption>
                <thead>
                    <tr>
                        <th scope="col">{shouldShowMobileView ? 'Prop' : 'Prop'}</th>
                        {!shouldShowMobileView && (
                            <>
                                <th scope="col">Pick</th>
                                <th scope="col">Rating</th>
                            </>
                        )}
                    </tr>
                </thead>
                <tbody>
                    {Object.keys(propReasons[position][player])
                        .filter(punit => punit != 'PlayerName' && punit != 'SDPlayerId')
                        .map(punit => {
                            let pr = propReasons[position][player][punit];
                            const isExpanded = expandedRows.has(punit);

                            if (shouldShowMobileView) {
                                return (
                                    <React.Fragment key={punit}>
                                        <tr>
                                            <td className="p-0">
                                                <div
                                                    className="d-flex justify-content-between align-items-center p-3"
                                                    onClick={() => togglePanel(punit)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <span>{punit}</span>
                                                    <span className={`text-primary transition-transform duration-300 ${isExpanded ? 'rotate-180' : ''}`}>
                                                        {isExpanded ? '−' : '+'}
                                                    </span>
                                                </div>

                                                <div
                                                    className={`
                                                        overflow-hidden transition-all duration-300 ease-in-out
                                                        ${isExpanded ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}
                                                    `}
                                                >
                                                    <div
                                                        className="border-t p-3"
                                                        onClick={(e) => {
                                                            e.stopPropagation();
                                                            toggleShowReason(
                                                                player,
                                                                propReasons[position][player].SDPlayerId,
                                                                propReasons[position][player].PlayerName,
                                                                propData.StarsFavId,
                                                                propData.StarsFavId == propData.HomeId ? propData.AwayName : propData.HomeName,
                                                                punit,
                                                                pr
                                                            );
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <div className="mb-3 flex flex-row justify-start items-center gap-x-2">
                                                            <strong>Pick: </strong>
                                                            <span>{`${pr.OverUnder} ${pr.PropVal}`}</span>
                                                        </div>
                                                        <div className="flex flex-row justify-start items-center gap-x-2">
                                                            <strong>Rating: </strong>
                                                            <div className="d-flex justify-content-center gap-1">
                                                                {[1, 2, 3, 4, 5].map(star => (
                                                                    <span key={star} className={getStarClassName(pr, star)}>
                                                                        star_rate
                                                                    </span>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </React.Fragment>
                                );
                            }

                            return (
                                <tr
                                    key={punit}
                                    onClick={() => toggleShowReason(
                                        player,
                                        propReasons[position][player].SDPlayerId,
                                        propReasons[position][player].PlayerName,
                                        propData.StarsFavId,
                                        propData.StarsFavId == propData.HomeId ? propData.AwayName : propData.HomeName,
                                        punit,
                                        pr
                                    )}
                                    style={{ cursor: 'pointer' }}
                                    className="hover:bg-gray-50 transition-colors duration-200"
                                >
                                    <td className="text-start">{punit}</td>
                                    <td>{`${pr.OverUnder} ${pr.PropVal}`}</td>
                                    <td>
                                        <div className="d-flex justify-content-center gap-1">
                                            {[1, 2, 3, 4, 5].map(star => (
                                                <span key={star} className={getStarClassName(pr, star)}>
                                                    star_rate
                                                </span>
                                            ))}
                                        </div>
                                    </td>
                                </tr>
                            );
                        })}
                </tbody>
            </table>
        </div>
    );
};